/* eslint-disable */

const img = require.context('../img', true);
import '../stylesheets/app';
import './app';
